import { useEffect, useMemo } from 'react';

import { PageDeletedSubDocument, ScheduledPageCanceledSubDocument } from 'data/generated/graphql';
import { useSubscription } from 'hooks/useSubscription';

const PageDeletedTopicQuery = {
  pageDeleted: PageDeletedSubDocument,
  scheduledPageCanceled: ScheduledPageCanceledSubDocument
} as const;

export type PageDTOSubscriptionTopic = keyof typeof PageDeletedTopicQuery;

interface UsePageDTOSubscriptionProps {
  allessehId: string;
  publicationKey: string;
  currentUserId: string;
  onDeleted: () => void;
  topic: PageDTOSubscriptionTopic;
}

export const usePageDTOSubscription = ({
  allessehId,
  publicationKey,
  currentUserId,
  onDeleted,
  topic
}: UsePageDTOSubscriptionProps) => {
  const subscribePayload = useMemo(() => ({ query: PageDeletedTopicQuery[topic] }), [topic]);

  const { data, error } = useSubscription({
    subscribePayload,
    publicationKey,
    enabled: !!allessehId && !!publicationKey
  });

  const topicData = data?.[topic];
  const deletedAllessehId = topicData?.allessehId;
  let user: string = '';

  switch (topic) {
    case 'pageDeleted':
      user = data?.pageDeleted?.deletedBy ?? '';
      break;
    case 'scheduledPageCanceled':
      user = data?.scheduledPageCanceled?.canceledBy ?? '';
      break;
    default:
      break;
  }

  useEffect(() => {
    if (
      deletedAllessehId &&
      deletedAllessehId === allessehId &&
      typeof user === 'string' &&
      user.toLowerCase() !== currentUserId.toLowerCase()
    ) {
      onDeleted();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [topicData, allessehId, currentUserId, onDeleted]);

  return { error };
};
